import { createContext, useContext, useState, useEffect } from "react";

const ThemeContext = createContext();

export const ThemeProvider = ({ children }) => {
    const [theme, setTheme] = useState(() => { try { return localStorage.getItem("parto-theme") || "light"; } catch (e) { return "light"; } });

    useEffect(() => {
        try { localStorage.setItem("parto-theme", theme); } catch (e) { /* Speicher gesperrt */ }
        const root = document.documentElement;
        if (theme === "dark") root.classList.add("dark");
        else root.classList.remove("dark");
    }, [theme]);

    const toggleTheme = () => setTheme((p) => (p === "dark" ? "light" : "dark"));

    return (
        <ThemeContext.Provider value={{ theme, setTheme, toggleTheme }}>
            {children}
        </ThemeContext.Provider>
    );
};

export const useTheme = () => useContext(ThemeContext);
